// sliders.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';



export function initMarqueeSlider() {
    const sliders = document.querySelectorAll('.js-marquee-slider');

    sliders.forEach((sliderEl) => {
        const swiper = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 111,
            loop: true,
            allowTouchMove: false,
            // speed: 8000,
            // autoplay: {
            //     delay: 0,
            //     disableOnInteraction: true,
            // },
            freeMode: {
                enabled: true,
                momentum: false,
            },
            breakpoints: {
                0: {
                    spaceBetween: 40, // smaller gap on mobile
                },
                768: {
                    spaceBetween: 111, // default on tablet/desktop
                },
            },
        });
    });
}

export function initTestimonialSlider() {
    const sliders = document.querySelectorAll('.js-testimonial-slider');

    sliders.forEach((sliderEl) => {
        // Find the thumbs container relative to this slider
        const thumbsEl = sliderEl.closest('.testimonial-slider')?.querySelector('.js-testimonial-thumbs');

        // Init thumbs first
        const thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 1, // adjust how many thumbnails show
            spaceBetween: 10,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
        });

        // Init main slider
        const swiper = new Swiper(sliderEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            allowTouchMove: false,
            navigation: {
                nextEl: sliderEl.closest('.testimonial-slider')?.querySelector('.swiper-next'),
                prevEl: sliderEl.closest('.testimonial-slider')?.querySelector('.swiper-prev'),
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    });
}

export function initCardsSlider() {
    const sliders = document.querySelectorAll('.js-cards-slider');

    sliders.forEach((sliderEl) => {
        const swiper = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 70,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3000, // time in ms between slides
                disableOnInteraction: false, // keep autoplay after user swipes
            },

        });
    });
}

export function initIconSlider() {
    const sliders = document.querySelectorAll('.js-icon-slider');

    sliders.forEach((sliderEl) => {
        const swiper = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            freeMode: {
                enabled: true,
                momentum: false,
            },

        });
    });
}


export function initMobileSwiper() {
    var $container = $(".mobile-swiper");

    if (window.innerWidth <= 768 && !$container.hasClass("swiper-initialized")) {

        // Init Swiper
        new Swiper(".mobile-swiper.swiper", {
            slidesPerView: 1.2,
            spaceBetween: 20,
        });
    }
}